package com.qrkontaq.ui.sections.header.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.localization.LocalAppStrings
import com.qrkontaq.ui.sections.header.IconButtonStyle
import com.qrkontaq.ui.theme.AppColors
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem

@Composable
internal fun CloseButton(onClick: () -> Unit) {
    val strings = LocalAppStrings.current
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        modifier = IconButtonStyle
            .toModifier()
            .backgroundColor(colors.surfaceVariant)
            .onClick { onClick() }
            .attrsModifier {
                attr("role", "button")
                attr("aria-label", strings.ariaCloseMenu)
                attr("tabindex", "0")
                onKeyDown {
                    if (it.key == "Enter" || it.key == " ") {
                        it.preventDefault()
                        onClick()
                    }
                }
            },
        contentAlignment = Alignment.Center
    ) {
        SpanText("✕", Modifier.fontSize(1.5.cssRem).attrsModifier { attr("aria-hidden", "true") })
    }
}
